/**
 * Sentinel value for the "None" option in the tactic selector. Must be a
 * non-empty string — Radix Select (sonar-builder) rejects empty-string item
 * values. Mapped back to `undefined` (no tactic) at the modal edge.
 */
export const NONE_TACTIC_VALUE = '__none__';
